import { useEffect, useState } from "react";
import { api, DEFAULT_TIERS } from "./config";

// Lightweight per-app cache so concurrent mounts don't thrash the endpoint.
let _cache = null;
let _inflight = null;

const normalize = (rows) => rows.map((t) => ({ ...t, key: t.tier_key }));

async function _fetchTiers() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = api
    .get("/tiers")
    .then((r) => {
      _cache = normalize(r.data);
      _inflight = null;
      return _cache;
    })
    .catch(() => {
      _inflight = null;
      return DEFAULT_TIERS;
    });
  return _inflight;
}

export function invalidateTiersCache() {
  _cache = null;
}

export function useTiers() {
  const [tiers, setTiers] = useState(_cache || DEFAULT_TIERS);
  const [loading, setLoading] = useState(!_cache);
  useEffect(() => {
    let alive = true;
    _fetchTiers().then((t) => {
      if (alive) {
        setTiers(t);
        setLoading(false);
      }
    });
    return () => {
      alive = false;
    };
  }, []);
  return { tiers, loading };
}
